import drVeronikaSolopova from "@/assets/images/speakers/dr-veronika-solopova.jpg";
import tatianaCojocari from "@/assets/images/speakers/tatiana-cojocari.jpg";
import drYehorBrailian from "@/assets/images/speakers/dr-yehor-brailian.jpg";
import annaRomandash from "@/assets/images/speakers/anna-romandash.jpg";


const RESEARCHERS = [
  {
    id: 1,
    url: "speaker/dr-veronika-solopova",
    name: "Dr. Veronika Solopova",
    title: "Post-doctoral Research Assistant",
    company: "Technische Universität Berlin",
    image: drVeronikaSolopova,
    show: true,
    textTitle:
      "Automating Fact-Checking: Enhancing Disinformation Resilience in the EU: ",
    text: "The paper combines legal, ethical, and technical perspectives to propose AI-powered solutions that can assist governmental agencies, NGOs, news outlets, and intelligence services in disinformation detection and resilience against misinformation.",
    downloadLink: "/pdf/Solopova_From_Trust_to_Truth.pdf",
  },
  {
    id: 2,
    url: "speaker/dr-tatiana-cojocari",
    name: "Dr. Tatiana Cojocari",
    title: "Researcher & Disinformation Expert",
    company: "WatchDog.MD Community",
    image: tatianaCojocari,
    show: true,
    textTitle:
      "Soviet Nostalgia and Disinformation: Understanding Anti-Western Sentiment in Moldova",
    text: "This study explores the correlation between Soviet nostalgia and the consumption of anti-Western propaganda in the Republic of Moldova. It hypothesizes that individuals emotionally connected to the Soviet Union are more likely to view Western countries negatively and oppose European integration, with media consumption, political views, and cultural memory as key factors shaping these preferences.",
    downloadLink: "/pdf/Cojocari_Soviet_Nostalgia_and_the_European_Future.pdf",
  },
  {
    id: 3,
    url: "speaker/dr-yehor-brailian",
    name: "Dr. Yehor Brailian",
    title: "Analyst",
    company: "Detector media",
    image: drYehorBrailian,
    show: true,
    textTitle: "russian Propaganda and German Sentiment in Occupied Ukraine: ",
    text: "This research explores russian propaganda in the occupied territories of Ukraine and its impact on German foreign policy and public opinion. By analyzing russian narratives through Telegram, VK, and propaganda outlets, the study aims to develop policy recommendations for improving strategic communications between Ukraine, the occupied regions, and Germany.",
    downloadLink:
      "/pdf/Brailain_Germany_in_Russian_propaganda_in_the_occupied_territories.pdf",
  },
  {
    id: 4,
    url: "speaker/anna-romandash",
    name: "Anna Romandash",
    title: "Journalist",
    image: annaRomandash,
    show: true,
    textTitle:
      "Combating russian Misinformation through Transborder Media Collaboration:",
    text: "This research examines the role of cross-border media cooperation between Ukrainian and European newsrooms to counter Kremlin-backed misinformation campaigns and russian media narratives. It focuses on strengthening content sharing and building networks between local media, freelancers, and fact-checkers to enhance Ukraine’s influence in the Western media space and shape more accurate coverage of Ukraine-related issues.",
    downloadLink: "/pdf/Romandash_Horizontal_Media_Networks_to_the_Rescue.pdf",
  }
  // {
  //   id: 5,
  //   url: "moderator/dmytro-iarovyi",
  //   name: "Dr. Dmytro Iarovyi",
  //   title: "Curator of research fellowship section",
  //   image: dmytroIarovyi,
  //   show: true,
  //   text: "Associate Professor at the Graduate Department of Social Sciences and Humanities at Kyiv School of Economics. ",
  //   // downloadLink: "/pdf/From_Curator.pdf",
  // },
];

export default RESEARCHERS;
